/**
 * Generated from ch7_p01.fla
 */
export function ch7_p01(this: Ich7_p01) {
	const bg = this.bg;
	ch7_p01_hh_ch7_72dpi_p01psdAssetbg.call(this.bg);
	bg.x = 840.75;
	bg.y = 384;
	bg.width = 1646.50;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const sideBushes = this.sideBushes;
	ch7_p01_hh_ch7_72dpi_p01psdAssetsidebushes.call(this.sideBushes);
	sideBushes.x = 166.25;
	sideBushes.y = 555;
	sideBushes.width = 332.50;
	sideBushes.height = 232.00;
	sideBushes.alpha = 1.00;
	if (sideBushes.onLayout) sideBushes.onLayout();
	const grassBg = this.grassBg;
	ch7_p01_hh_ch7_72dpi_p01psdAssetgrassbg.call(this.grassBg);
	grassBg.x = 1357.5;
	grassBg.y = 490.25;
	grassBg.width = 613.00;
	grassBg.height = 262.50;
	grassBg.alpha = 1.00;
	if (grassBg.onLayout) grassBg.onLayout();
	const barn = this.barn;
	ch7_p01_hh_ch7_72dpi_p01psdAssetbarnandstilo.call(this.barn);
	barn.x = 1446.25;
	barn.y = 291.5;
	barn.width = 435.50;
	barn.height = 357.00;
	barn.alpha = 1.00;
	if (barn.onLayout) barn.onLayout();
	const grassPath = this.grassPath;
	ch7_p01_hh_ch7_72dpi_p01psdAssetgrassandpath.call(this.grassPath);
	grassPath.x = 832;
	grassPath.y = 616.25;
	grassPath.width = 1664.00;
	grassPath.height = 303.50;
	grassPath.alpha = 1.00;
	if (grassPath.onLayout) grassPath.onLayout();
	const shadow = this.shadow;
	ch7_p01_hh_ch7_72dpi_p01psdAssetshadow.call(this.shadow);
	shadow.x = 727;
	shadow.y = 682.75;
	shadow.width = 271.00;
	shadow.height = 170.50;
	shadow.alpha = 1.00;
	if (shadow.onLayout) shadow.onLayout();
	const holly = this.holly;
	ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_hollyhorse.call(this.holly);
	holly.x = 658.5;
	holly.y = 748;
	holly.width = 622.00;
	holly.height = 694.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetbg(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetsidebushes(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetsidebushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("sidebushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetgrassbg(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("grassbg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetbarnandstilo(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetbarnandstilo) {
	if (this.setLayoutTexture) this.setLayoutTexture("barnandstilo", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetgrassandpath(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassandpath) {
	if (this.setLayoutTexture) this.setLayoutTexture("grassandpath", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetshadow(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetshadow) {
	if (this.setLayoutTexture) this.setLayoutTexture("shadow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_hollyhorse(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_hollyhorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p01_hollyhorse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeRRframe(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeLLframe(this: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich7_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p01Sprite extends Ich7_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p01Text extends Ich7_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p01Polygon extends Array<number> {
}
interface Ich7_p01 {
	readonly bg: Ich7_p01_hh_ch7_72dpi_p01psdAssetbg;
	readonly sideBushes: Ich7_p01_hh_ch7_72dpi_p01psdAssetsidebushes;
	readonly grassBg: Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassbg;
	readonly barn: Ich7_p01_hh_ch7_72dpi_p01psdAssetbarnandstilo;
	readonly grassPath: Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassandpath;
	readonly shadow: Ich7_p01_hh_ch7_72dpi_p01psdAssetshadow;
	readonly holly: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_hollyhorse;
	readonly frameRight: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeRRframe;
	readonly frameLeft: Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeLLframe;
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetbg extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetsidebushes extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassbg extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetbarnandstilo extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetgrassandpath extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetshadow extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_hollyhorse extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeRRframe extends Ich7_p01Sprite {
}
interface Ich7_p01_hh_ch7_72dpi_p01psdAssetchp7_p01_wcframeLLframe extends Ich7_p01Sprite {
}
